import { playSound, Sound } from '~/assets/sounds';
import { StyledTabButton } from '../MenuTabs/MenuTabs.styled';
import { ITabsContainerProps } from '../TabsContainer';
import { Text } from '../Text';
import {
	StyledContainer,
	StyledFade,
	StyledTab,
	StyledTabs,
	StyledTabsWrapper,
} from './CategoryTabs.styled';

export interface ICategoryTab {
	name: string;
	icon: string;
}

interface ICategoryTabsProps {
	tabs: ICategoryTab[];
	fadeColor?: string;
}

const CategoryTabs = ({
	tabs,
	fadeColor = '#111314',
	activeIndex,
	handlePrev,
	handleNext,
	setIndex,
	...props
}: ICategoryTabsProps &
	ITabsContainerProps &
	React.HTMLAttributes<HTMLDivElement>) => (
	<StyledContainer {...props}>
		<StyledTabButton>Q</StyledTabButton>
		<StyledTabsWrapper>
			<StyledTabs
				activeIndex={activeIndex}
				handlePrev={handlePrev}
				handleNext={handleNext}
				setIndex={setIndex}
			>
				{tabs.map((tab, index) => (
					<StyledTab
						key={index}
						onMouseEnter={() => playSound(Sound.LinkCursor)}
					>
						<img src={tab.icon} />
						<Text>{tab.name}</Text>
					</StyledTab>
				))}
			</StyledTabs>
			<StyledFade $color={fadeColor} />
		</StyledTabsWrapper>
		<StyledTabButton>E</StyledTabButton>
	</StyledContainer>
);

export { CategoryTabs };
